import { Textarea } from "@/components/ui/textarea";
import { useTheme } from "@/components/ui/theme-provider";

interface TextQuestionProps {
  value: string;
  onChange: (value: string) => void;
}

export const TextQuestion = ({ value, onChange }: TextQuestionProps) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  
  return (
    <Textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`min-h-[100px] ${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border-green-500/30 text-foreground focus:border-green-500 focus:ring-green-500 text-base md:text-sm`}
      placeholder="Tell us more..."
    />
  );
};